import { MutableRefObject, useEffect } from 'react';
import { LiveDraft } from '@utils/editors/live-transcript-state.ts';

export const useLiveTranscriptUnsavedWarning = (
  rows: MutableRefObject<LiveDraft[]>
) =>
  useEffect(() => {
    const warn = (event: BeforeUnloadEvent) => {
      if (!rows.current.some(row => row.dirty)) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [rows]);
